export default __webpack_public_path__ + "static/media/follow-user.783fb430.svg";